var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcThumbUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Thumbs_x5F_Up",
    d: "M23,10.917c0-1.11-0.9-2-2-2h-6.32l0.961-4.57c0.021-0.1,0.029-0.21,0.029-0.32 c0-0.41-0.17-0.79-0.439-1.06l-1.061-1.05l-6.58,6.58C7.22,8.867,7,9.367,7,9.917v10c0,1.104,0.896,2,2,2h9 c0.83,0,1.54-0.5,1.84-1.222l3.02-7.049C22.95,13.417,23,13.177,23,12.917V10.917 M1,21.917h4v-12H1V21.917z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThumbUp);
export default __webpack_public_path__ + "static/media/ic_thumb_up.850da7052e4ea0c4442b2284b3d0236f.svg";
export { ForwardRef as ReactComponent };